module.exports = __webpack_public_path__ + "img/kuechenreinigung.8d52646.png";